import { render, staticRenderFns } from "./groupAward.vue?vue&type=template&id=0a729729&scoped=true"
import script from "./groupAward.vue?vue&type=script&lang=js"
export * from "./groupAward.vue?vue&type=script&lang=js"
import style0 from "./groupAward.vue?vue&type=style&index=0&id=0a729729&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a729729",
  null
  
)

export default component.exports